import ViewMode from '../../../javascripts/editor/view_mode';
import '../../../styles/layout/_editor';

$(() => {
  const viewMode = new ViewMode('oembed[url]');
  viewMode.replace();
});
